module.exports = __webpack_public_path__ + "static/media/laptop.05a36e97.svg";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/images/laptop.svg
// module id = 383
// module chunks = 0